<div class="app-account-header">
  <img src="assets/icons/icon-account.svg" alt="">
  <div class="app-user-name">
    {{ email() }}
  </div>
  @if (customerNumber()) {
    <div class="app-user-id">
      Kundennummer: {{ customerNumber() }}
    </div>
  }
</div>
